import React, { useState } from "react";
import { Modal, Button, Image } from "react-bootstrap";
import { short_videos_delete_request } from "../../../../../store/actions/SuperAdminActions/adminShortVideosAction";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import restoreimg from "../../../../../assets/images/UserManagement/ResetDrive.svg";

const SuperAdminDeleteShortvideo = (props) => {
  const [showDeleteshort, seShowDeletShort] = useState(false);
  const history = useHistory();


  const onSuccessDeleteref = () => {
    seShowDeletShort(false);

    if (props.onClickCloseView) {
      props.onClickCloseView();
      history.push("/superadmin/short-videos");
    }

    if(props.onSuccess){
    props.onSuccess() 
    }

  };


  const onErrorDeleteref = () => {
    seShowDeletShort(false);
  };


  const handleCloseDeleteReq = () => {
    const token = props.auth.user.accessToken;
    props.short_videos_delete_request(
      props.id,
      token,
      onSuccessDeleteref,
      onErrorDeleteref
    );
  };

  const onDeleteNo = () => {
    seShowDeletShort(false);
  };

  const handleShowDeleteOffer = () => {
    seShowDeletShort(true);
  };
  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={handleShowDeleteOffer}
      >
        <Image
          src={props?.status == false ? require("../../../../../assets/images/UserManagement/Delete.svg") : restoreimg }
          alt="Delete short"
          title={props?.status == false ? "mark this video as archive" : "restore video from archive"}
          fluid
          style={{width:"16px"}}
        />
        
      </Button>
      <Modal show={showDeleteshort} onHide={onDeleteNo} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title>Archive Video</Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
           Are you sure you want to {props?.status == false ? "mark this video as archive" : "restore video from archive"}?
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={onDeleteNo}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={handleCloseDeleteReq}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

SuperAdminDeleteShortvideo.propTypes = {
  auth: PropTypes.object.isRequired,
  short_videos_delete_request: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { short_videos_delete_request })(
  SuperAdminDeleteShortvideo
);
